export const USER_LOGS_ACTION_TYPE = {
	CREATE: 1,
	DELETE: 2,
	ADD: 3,
	REMOVE: 4,
	EDIT: 5
};
